import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';

import placeholder from 'lib/placeholder';

import Carousel from './Carousel';

const Partners = ({ className }) => (
  <section className={className}>
    <Heading className="mb-4 text-center" size="size2">
      {placeholder('titles.ourPartners')}
    </Heading>
    <Carousel />
  </section>
);

Partners.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default Partners;
